import React, { useState, useEffect } from 'react';
import Login from './components/Login/Login';
import OptionsScreen from './components/OptionsScreen/OptionsScreen';
import VehiclePickup from './components/VehiclePickup/VehiclePickup';
import VehicleReturn from './components/VehicleReturn/VehicleReturn';

function App() {
  const [user, setUser] = useState(() => {
    try {
      const savedUser = localStorage.getItem('user_data');
      return savedUser ? JSON.parse(savedUser) : null;
    } catch (error) {
      console.error('Error parsing user data from localStorage:', error);
      localStorage.removeItem('user_data');
      localStorage.removeItem('auth_token');
      return null;
    }
  });
  const [currentScreen, setCurrentScreen] = useState('options');

  const handleLogin = (userData) => {
    setUser(userData);
    setCurrentScreen('options');
  };

  const handleLogout = () => {
    setUser(null);
    setCurrentScreen('options');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_data');
  };

  const handleNavigate = (screen) => {
    setCurrentScreen(screen);
  };

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  // Render different screens based on currentScreen state
  switch (currentScreen) {
    case 'options':
      return <OptionsScreen onNavigate={handleNavigate} />;
    case 'pickup':
      return <VehiclePickup onNavigate={handleNavigate} />;
    case 'return':
      return <VehicleReturn onBack={() => setCurrentScreen('options')} />;
    default:
      return <OptionsScreen onNavigate={handleNavigate} />;
  }
}

export default App;